import ModelUtil from '@leverege/model-util';
import GeoPointModel from "./GeoPointModel.js";
import GeoShapeModel from "./GeoShapeModel.js";
const TYPE = 'molten.googleMapRenderer.GroupClusterModel';
function create(layerName, name, objectType, extend) {
  return {
    ...GeoShapeModel.create(layerName, name, objectType),
    type: TYPE,
    visible: false,
    shouldCluster: true,
    lineStyle: {
      color: {
        type: 'colorizer.Value',
        color: '#ffffff'
      },
      // Colorizer,
      width: 1,
      style: 'default',
      dashArray: null,
      // [ 8, 3 ]
      pattern: null,
      opacity: 1,
      cap: 'round',
      join: 'round'
    },
    fillStyle: {
      color: {
        type: 'colorizer.Value',
        color: '#23A78D'
      },
      // Colorizer,
      pattern: null,
      // for image bgs
      opacity: 0.8
    },
    labelStyle: {
      visible: true,
      color: {
        type: 'colorizer.Value',
        color: '#ffffff'
      },
      // Colorizer,
      pattern: null,
      // for image bgs
      opacity: 1.0,
      attribute: 'name',
      allowOverlap: false,
      ignorePlacement: false,
      size: 16
    },
    rolloverFillStyle: {
      hasColor: true,
      hasPattern: false,
      hasOpacity: true,
      color: {
        type: 'colorizer.Value',
        color: '#126253'
      },
      // Colorizer,
      pattern: null,
      // for image bgs
      opacity: 0.8
    },
    ...extend,
    backupRenderer: extend?.backupRenderer || GeoPointModel.create(layerName, name, objectType, {
      visible: true
    })
  };
}
function update(model, context) {
  const {
    backupRenderer
  } = context;
  let nModel = GeoPointModel.update(model, context);
  if (!model?.backupRenderer) {
    nModel = {
      ...nModel,
      backupRenderer
    };
  }
  return nModel;
}
export default {
  ...GeoShapeModel,
  create,
  TYPE,
  ...ModelUtil.createAllValue('backupRenderer'),
  ...ModelUtil.createAllValue('shouldCluster', null, null, {
    defaultValue: true
  }),
  update
};